/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Tea_Lot_StatusInputs */

const vi_trace_tea_lot_status = /** @type {(inputs: Trace_Tea_Lot_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trạng thái`)
};

/**

* @param {Trace_Tea_Lot_StatusInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_tea_lot_status = /** @type {((inputs?: Trace_Tea_Lot_StatusInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Tea_Lot_StatusInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_tea_lot_status(inputs)
});